import * as React from 'react';

import { Button } from 'components/button/Button';

import s from './EventHeader.scss';

interface IProps {
  children: React.ReactNode;
  heading?: string; // cloned into component
  date?: string;
  time?: string;
  hidden?: boolean;
  link?: string;
  linkText?: string;
}

export const EventHeader = ({
  children,
  heading,
  date,
  time,
  hidden = false,
  link,
  linkText,
}: IProps) => {

  const dateTime = (time !== '0:00') ?  [date, time].filter(Boolean).join(' | ') : date;

  return (
    <div className={s('eventHeader', { hidden })}>
      <h1 className={s.eventHeader__heading} property="name">
        {heading}
      </h1>
      {!hidden && (
        <>
          <div className={s.eventHeader__date} property="startDate">
            {dateTime}
          </div>
          <div className={s.eventHeader__summary}>{children}</div>
          {link && (
            <div className={s.eventHeader__buttonWrap}>
              <Button to={link}>{linkText}</Button>
            </div>
          )}
        </>
      )}
    </div>
  );
};
